@file:Suppress("unused")

package pl.decks.chartjs.style

import pl.decks.chartjs.model.JSEnum

enum class BorderJoinStyle(override val jsValue: String) : JSEnum {
    Round("round"),
    Bevel("bevel"),
    Miter("miter"),
}
